import { TweenMax, Linear } from '@hh/global.js'

class AnnouncementBar extends HTMLElement {
  constructor () {
    super()
    this.countDownData = this.getAttribute('data-countdown')
    this.countDownInterval = ''

    this.enableTransparent = document.querySelector('hh-sticky-header')?.classList.contains('header-wrapper--transparent')

    document.addEventListener('DOMContentLoaded', () => {
      this.initElements()
    })

    if (this.enableTransparent) {
      this.adjustBodySpace()
      window.addEventListener('resize', this.adjustBodySpace)
    }
  }

  initElements () {
    const item = this.querySelector('.js-item')
    const inner = this.querySelector('.js-content')
    const containerWidth = inner?.getBoundingClientRect().width
    const itemWidth = item?.getBoundingClientRect().width

    if (this.getAttribute('data-enable-animation')) {
      const ammountToTween = -(item.clientWidth);
      const tween = TweenMax.to(inner, parseInt(10), { x: ammountToTween, ease: Linear.easeNone, repeat: -1 });

      inner?.addEventListener('mouseenter', () => {
        tween.timeScale(0.15);
      });

      inner?.addEventListener('mouseleave', () => {
        tween.timeScale(1);
      });
    }

    const numberNeeded = 8
    for (var i = 0; i < numberNeeded - 1; i ++) {
      const newTextEl = item?.cloneNode(true)
      if (newTextEl) inner?.appendChild(newTextEl)
    }

    if (this.countDownData) this.initCountDown()
  }

  initCountDown () {
    this.countDownInterval = setInterval(this.setCountDown.bind(this), 1000)
  }

  setCountDown () {
    const countDown = new Date(this.countDownData).getTime()
    const now = new Date().getTime()
    const timeleft = countDown - now

    const days = Math.floor(timeleft / (1000 * 60 * 60 * 24))
    const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeleft % (1000 * 60 )) / (1000))

    let countDownStr = ''
    if (timeleft > 0) {
      countDownStr += `${days} ${(days > 1 ? 'DAYS' : 'DAY')}, `
      countDownStr += `${hours} ${(hours > 1 ? 'HOURS' : 'HOUR')}, `
      countDownStr += `${minutes} ${(minutes > 1 ? 'MINUTES' : 'MINUTE')}`
    } else {
      countDownStr = `0 DAYS, 0 HOUR, 0 MINUTE`
      clearInterval(this.countDownInterval)
    }

    this.querySelectorAll('.js-countdown-timer')
      .forEach(element => element.innerHTML = countDownStr)
  }

  isEnabledAnimation () {
    const query = '(prefers-reduced-motion: reduce)'
    const hasOSReducedMotion = window.matchMedia(query).matches
    return !hasOSReducedMotion && !this.classList.contains('announcement-bar__disabled')
  }

  connectedCallback () {
    if (this.isEnabledAnimation()) this.classList.add('playing')
  }

  slowDownAnimation () {
    this.classList.remove('playing')
  }

  defaultAnimation () {
    this.classList.add('playing')
  }

  adjustBodySpace () {
    const height = this.offsetHeight || 0
    const mainContent = document.querySelector('#main')
    if (height && mainContent) mainContent.style.marginTop = height + 'px'
  }
}

window.customElements.define('announcement-bar', AnnouncementBar)
